"use strict";

module.exports = function (product, product_type) {
  var from = product.product_type;

  if (from === product_type) {
    return function (f) {
      return f;
    };
  }

  if (from.match(/letterpress/i)) {
    return function convertToStandard() {
      this.saveTheDates.components = this.letterpressSaveTheDates.all();
      this.smallEnclosures.components = this.letterpressSmallEnclosures.all();
      this.letterpressSaveTheDates.clear();
      this.letterpressSmallEnclosures.clear();
    };
  }

  return function convertToLetterpress() {
    this.letterpressSaveTheDates.components = this.saveTheDates.all();
    this.letterpressSmallEnclosures.components = this.smallEnclosures.all();
    this.saveTheDates.clear();
    this.smallEnclosures.clear();
  };
};